import React, { useState, useEffect, useCallback } from 'react';
import { API_ADDRESS, PAGE_TITLE_BASE } from './constants.js';
import { useParams } from "react-router-dom";
import { InstagramEmbed } from 'react-social-media-embed';
import { useNavigate } from "react-router";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Icon, Dimmer, Loader, Segment, Card, CardContent, CardHeader } from 'semantic-ui-react'
import tippy from 'tippy.js';
import { ConcertCard } from './ConcertCard';
import ReactDOMServer from "react-dom/server";
import { ConcertMap } from './ConcertMap';
import { PlaylistCard } from './PlaylistCard';

export function Artist(props) {
  const navigate = useNavigate();
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  const [artist, setArtist] = useState({});
  const [name, setName] = useState('Artist');
  const [concerts, setConcerts] = useState({});

  document.title = name + ' | ' + PAGE_TITLE_BASE;

  const search = useCallback(() => {  
    var url = `${API_ADDRESS}/artist/${id}`;

    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        setArtist(json);
        let name = json.last_name;
        if('first_name' in json) {
          name = json.first_name + " " + json.last_name;
        }
        let concerts = {};
        json.concerts.map(function(concert) {
          concerts[concert.concert_id] = concert;
          return concert;
        });
        setConcerts(concerts);
        setName(name);
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, [id]); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  const onClickHandler = (e, link) => {
    if(e.ctrlKey || e.metaKey){
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  }

  return (
    <div>
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
        <h1>{name}</h1>
        {artist === {} && 
          <Card color='orange' style={{width:'100%'}}>
            <CardContent>
              <CardHeader>No artist found</CardHeader>
            </CardContent>
          </Card>
        }
        <div className="artist-links">
          {'spotify' in artist &&
            <div>
              <iframe data-testid="embed-iframe" style={{borderRadius: "12px"}} src={"https://open.spotify.com/embed/artist/" + artist.spotify} width="500" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="spotify"></iframe>
            </div>
          }
          {'instagram' in artist &&
            <div>
              <InstagramEmbed url={"https://www.instagram.com/" + artist.instagram} width={500}/>
            </div>
          }
          {'website' in artist &&
            <div>
              <a href={artist.website} target="_blank" rel="noreferrer" style={{ fontSize: "xx-large" }}><Icon name="globe"/>Website</a>
            </div>
          }
        </div>
        {'acts' in artist &&
          <div className="artists-section">
            <h2>Acts</h2>
            <div className="Cards">
              {artist.acts.map(function(act, i) {
                let color = 'orange';
                if(i % 7 === 1) { color = 'teal'; }
                if(i % 7 === 2) { color = 'purple'; }
                if(i % 7 === 3) { color = 'green'; }
                if(i % 7 === 4) { color = 'yellow'; }
                if(i % 7 === 5) { color = 'red'; }
                if(i % 7 === 6) { color = 'pink'; }

                return <Card key={act.act_id}
                  color={color}
                  style={{width: '290px'}}
                  onClick={(e) => onClickHandler(e, '/act/' + act.act_id)}
                >
                  <CardContent>
                    <CardHeader>{act.name}</CardHeader>
                  </CardContent>
                </Card>
              })}
            </div>
          </div>
        }
        <div className='calendar'>
          <h1>Concert Calendar</h1>
          <div className='demo-app-main'>
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: ''
              }}
              editable={false}
              selectable={false}
              selectMirror={false}
              dayMaxEvents={false}
              weekends={true}
              firstDay={1}
              showNonCurrentDates={false}
              navLinks={false}
              slotEventOverlap={false}
              dayHeaderFormat={{weekday: 'long'}}
              events={artist.concerts}
              locale={'en-gb'}
              height={'500px'}
              eventDisplay={'block'}
              eventContent={renderEventContent}
              eventDidMount={ (info) => {
                tippy(info.el, {
                  trigger: 'click',
                  touch: 'hold',
                  allowHTML: true,
                  content:
                     ReactDOMServer.renderToString(<ConcertCard single_concert={concerts[info.event.extendedProps.concert_id]}/>)
               })
            }}
            />
          </div>
        </div>
        {(artist.markers && Object.keys(artist.markers).length > 0) &&
          <ConcertMap markers={artist.markers} title={'Upcoming Concerts Map'}/>
        }
        {(artist.playlist && Object.keys(artist.playlist).length > 0) &&
          <div className='playlist'>
            <h1>Latest Releases</h1>
            <p>We maintain a playlist of all the latest releases from the British vocal jazz scene. The following tracks by this artist have been featured on the playlist:</p>
            <div className="Cards">
              {Object.keys(artist.playlist).length > 0 && Object.keys(artist.playlist).sort().reverse().map(function(date, i) {
                let entries_for_date = artist.playlist[date];
                return <PlaylistCard key={date} date={date} playlist={entries_for_date} i={i}/>
              })}
              {Object.keys(artist.playlist).length === 0 &&
                <b>No results</b>
              }
            </div>
          </div>
        }
      </Segment>
    </div>
  );
}


function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b><span> </span>
      <i>{eventInfo.event.title}</i>
    </>
  )
}